import axios from "axios";
import API_BASE_URL from "../../../config/api";
import { useState, useEffect, useCallback } from "react";
import AddBot from "./AddBot/AddBot";
import "./bots.css";
import { Modal, Button } from "react-bootstrap";
import { useAuth } from "../../../hooks/AuthProvider";

const Bots = () => {
  const [bots, setBots] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editBot, setEditBot] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  const fetchBots = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API_BASE_URL}/api/v1/bot`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBots(data || []);
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  }, [token]);

  useEffect(() => { fetchBots(); }, [fetchBots]);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_BASE_URL}/api/v1/bot/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setBots((prev) => prev.filter((b) => b.id !== id));
    } catch (err) {
      console.error(err.message);
    }
    setDeleteTarget(null);
  };

  const handleEdit = (bot) => {
    setEditBot(bot);
    setShowForm(true);
  };

  const handleFormSuccess = () => {
    setShowForm(false);
    setEditBot(null);
    fetchBots();
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditBot(null);
  };

  return (
    <div>
      {!showForm ? (
        <>
          <div className="botsHeader">
            <h3>AI Marketplace Bots</h3>
            <button className="botsCreateBtn" onClick={() => setShowForm(true)}>
              + Create Bot Template
            </button>
          </div>

          {loading && <div className="botsLoading">Loading...</div>}

          {!loading && bots.length === 0 && (
            <div className="botsEmpty">
              <img src="/empty-folder.png" alt="no bots" width="80" />
              <h4>No bots created yet</h4>
              <p>Start by creating your first AI bot template for the Marketplace.</p>
              <button className="botsCreateBtn" onClick={() => setShowForm(true)}>
                + Create Your First Bot
              </button>
            </div>
          )}

          {!loading && bots.length > 0 && (
            <div className="botsTable">
              <table>
                <thead>
                  <tr>
                    <th>Icon</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Compatibility</th>
                    <th>Price</th>
                    <th style={{ width: 160 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {bots.map((bot) => (
                    <tr key={bot.id}>
                      <td>
                         {bot.iconUrl ? (
                           <img src={bot.iconUrl} alt={bot.name} width="32" height="32" style={{ borderRadius: 8 }} />
                         ) : (
                           <div style={{ width: 32, height: 32, background: '#eee', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10 }}>🤖</div>
                         )}
                      </td>
                      <td className="botsNameCell">{bot.name}</td>
                      <td>{bot.type?.replace(/_/g, ' ')}</td>
                      <td>{bot.compatibility?.replace(/_/g, ' ')}</td>
                      <td>{bot.price} coins</td>
                      <td>
                        <button
                          className="botsDeleteBtn"
                          style={{ marginRight: 6, color: "#3b82f6", borderColor: "#3b82f6" }}
                          onClick={() => handleEdit(bot)}
                        >
                          Edit
                        </button>
                        <button
                          className="botsDeleteBtn"
                          onClick={() => setDeleteTarget(bot.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      ) : (
        <AddBot onSuccess={handleFormSuccess} onCancel={handleFormCancel} editBot={editBot} />
      )}

      <Modal show={!!deleteTarget} onHide={() => setDeleteTarget(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this bot template? This will not remove it from users who already purchased it but will hide it from the Store.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDeleteTarget(null)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => handleDelete(deleteTarget)}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Bots;
